const Icon = (props: any) => {
    return (
        <svg width={18} height={20} viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.827.004L13.132 0C16.139 0 18 1.98 18 5.005v9.99c0 3.01-1.847 4.983-4.828 5.002L4.867 20C1.86 20 0 18.02 0 14.995v-9.99c0-3.01 1.846-4.982 4.827-5zm.298 13.883a.75.75 0 000 1.5h7.798a.75.75 0 000-1.5H5.125zm-.75-3.799a.75.75 0 01.75-.75h7.798a.75.75 0 010 1.5H5.125a.75.75 0 01-.75-.75zm.75-5.287a.75.75 0 100 1.5h2.976a.75.75 0 000-1.5H5.125z"
                fill="currentColor"
            />
        </svg>
    );
};

export default Icon;
